// extracted by mini-css-extract-plugin
export default {"search-result":"search-result--svjNjHlpEa","searchResult":"search-result--svjNjHlpEa","title":"title--xWNokWd8wm","url":"url--tUaxxQaRM+","description":"description--T9phZwD79L"};